import AdminDashboardContent from '../../components/admin/AdminDashboardContent';
import AdminLayout from '../../components/admin/AdminLayout';

const DashboardPage = () => {
  return (
    <AdminLayout>
      <AdminDashboardContent />
    </AdminLayout>
  );
};

export default DashboardPage; 